import React, { useState, useEffect } from 'react';
import ChatInterface from './chatbot/ChatInterface';
import ChatSidebar from './chatbot/ChatSidebar';
import './LegalChatDashboard.css';

const LegalChatDashboard = () => {
  const [conversations, setConversations] = useState([]);
  const [activeConversationId, setActiveConversationId] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Initialize with a default conversation
  useEffect(() => {
    const defaultConversation = {
      id: Date.now(),
      title: 'New Conversation',
      timestamp: new Date().toISOString(),
      messages: [],
      documents: []
    };
    setConversations([defaultConversation]);
    setActiveConversationId(defaultConversation.id);
  }, []);

  // Get active conversation
  const activeConversation = conversations.find(
    conv => conv.id === activeConversationId
  );

  // Create new conversation
  const handleNewConversation = () => {
    const newConversation = {
      id: Date.now(),
      title: 'New Conversation',
      timestamp: new Date().toISOString(),
      messages: [],
      documents: []
    };
    setConversations([newConversation, ...conversations]);
    setActiveConversationId(newConversation.id);
  };

  // Select conversation
  const handleSelectConversation = (conversationId) => {
    setActiveConversationId(conversationId);
  };

  // Delete conversation
  const handleDeleteConversation = (conversationId) => {
    const updatedConversations = conversations.filter(
      conv => conv.id !== conversationId
    );
    setConversations(updatedConversations);
    
    // If deleted conversation was active, select first available
    if (conversationId === activeConversationId && updatedConversations.length > 0) {
      setActiveConversationId(updatedConversations[0].id);
    }
  };

  // Update conversation (messages, title, documents)
  const handleUpdateConversation = (updates) => {
    setConversations(prevConversations =>
      prevConversations.map(conv =>
        conv.id === activeConversationId
          ? { ...conv, ...updates }
          : conv
      )
    );
  };

  // Auto-generate conversation title from first message
  const generateTitle = (message) => {
    const words = message.split(' ').slice(0, 6).join(' ');
    return words.length > 40 ? words.substring(0, 40) + '...' : words;
  };

  return (
    <div className="legal-chat-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-left">
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          >
            <span className="icon">☰</span>
          </button>
          <h1>Propsten Legal Assistant</h1>
        </div>
        <div className="header-right">
          <span className="header-tag">Powered by AI</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        {/* Sidebar */}
        <ChatSidebar
          conversations={conversations}
          activeConversationId={activeConversationId}
          onNewConversation={handleNewConversation}
          onSelectConversation={handleSelectConversation}
          onDeleteConversation={handleDeleteConversation}
          collapsed={sidebarCollapsed}
        />

        {/* Chat Interface */}
        <div className="chat-main">
          {activeConversation ? (
            <ChatInterface
              conversation={activeConversation}
              onUpdateConversation={handleUpdateConversation}
              onGenerateTitle={generateTitle}
            />
          ) : (
            <div className="empty-state">
              <div className="empty-icon">💬</div>
              <h2>No conversation selected</h2>
              <p>Create a new conversation to get started</p>
              <button 
                className="btn-primary"
                onClick={handleNewConversation}
              >
                Start New Conversation
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalChatDashboard;
